import { GeneralSaleDao } from '../../../api/generalSale/dao/generalSale.dao';
import { GeneralSaleRepository } from '../../../api/generalSale/repository/generalSale.repository';
import {
  TypesActionsGeneralSale,
  LIST_GENERAL_SALE,
  SHOW_GENERAL_SALE,
  UPDATE_GENERAL_SALE,
  DELETE_GENERAL_SALE,
  GET_GENERAL_SALES,
  RESET_GENERAL_SALES_STATE,
} from './GeneralSaleTypes';
import {
  ResponseGeneralSale,
  GeneralSale,
} from '../../../types/generalSales/GeneralSales';

function listGeneralSale(
  payload: ResponseGeneralSale
): TypesActionsGeneralSale {
  return {
    type: LIST_GENERAL_SALE,
    payload,
  };
}

function showGeneralSale(payload: GeneralSale): TypesActionsGeneralSale {
  return {
    type: SHOW_GENERAL_SALE,
    payload,
  };
}

function updateGeneralSale(payload: GeneralSale): TypesActionsGeneralSale {
  return {
    type: UPDATE_GENERAL_SALE,
    payload,
  };
}

function deleteGeneralSale(payload: string): TypesActionsGeneralSale {
  return {
    type: DELETE_GENERAL_SALE,
    payload,
  };
}

function getGeneralSales(
  payload: ResponseGeneralSale
): TypesActionsGeneralSale {
  return {
    type: GET_GENERAL_SALES,
    payload,
  };
}

export function resetGeneralSaleState(): TypesActionsGeneralSale {
  return {
    type: RESET_GENERAL_SALES_STATE,
  };
}

export function listGeneralSaleAsync(
  numberPage: number,
  limit: number,
  accountId: string,
  search: string | null,
  filter: string | null
) {
  return async function (dispacth: Function) {
    const response = await GeneralSaleDao.list(
      accountId,
      numberPage,
      limit,
      search,
      filter
    );
    dispacth(listGeneralSale(response.data));
  };
}

export function showGeneralSaleAsync(
  id: string,
  accountId: string,
  callback: Function
) {
  return async function (dispatch: Function) {
    try {
      const response = await GeneralSaleDao.show(id, accountId);
      dispatch(showGeneralSale(response.data));
    } catch (error) {
      console.log(error);
      callback();
    }
  };
}

export function createGeneralSaleAsync(
  form: object,
  callbackSuccess: (generalSale: GeneralSale) => void,
  callbackError: Function
) {
  return async function (dispatch: Function) {
    try {
      const response = await GeneralSaleRepository.create(form);
      callbackSuccess(response.data);
      dispatch(showGeneralSale(response.data));
    } catch (error) {
      callbackError();
      console.log(error);
    }
  };
}

export function updateGeneralSaleAsync(
  form: object,
  callbackSuccess: Function,
  callbackError: Function
) {
  return async function (dispatch: Function) {
    try {
      const response = await GeneralSaleRepository.update(form);

      dispatch(updateGeneralSale(response.data));
      callbackSuccess();
    } catch (request) {
      callbackError();
    }
  };
}

export function deleteGeneralSaleAsync(
  form: {
    id: string;
    accountId: string;
  },
  callbackSuccess: Function,
  callbackError: Function
) {
  return async function (dispatch: Function) {
    try {
      await GeneralSaleRepository.delete(form);
      const response = await GeneralSaleDao.list(
        form.accountId,
        null,
        null,
        null,
        null
      );
      dispatch(deleteGeneralSale(form.id));
      dispatch(listGeneralSale(response.data));
      callbackSuccess();
    } catch (error) {
      console.log(error);
      callbackError();
    }
  };
}

export function getGeneralSalesAsync(
  numberPage: number,
  limit: number,
  accountId: string,
  search: string | null,
  filter: string | null
) {
  return async function (dispacth: Function) {
    const response = await GeneralSaleDao.list(
      accountId,
      numberPage,
      limit,
      search,
      filter
    );
    dispacth(getGeneralSales(response.data));
  };
}

export async function getGeneralSaleExcel(
  accountId: string,
  search: string | null,
  filter: string | null
) {
  return await GeneralSaleDao.getExcel(accountId, search, filter);
}
